__webpack_require__.p = "/MovieHub/";